export default __webpack_public_path__ + "static/media/placeholder_business06-fr-web.f48d248c.png";